import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQualityMonitor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.12 3H1.88C1.39325 3 1 3.32175 1 3.72V20.28C1 20.6782 1.39325 21 1.88 21H22.12C22.6068 21 23 20.6782 23 20.28V3.72C23 3.32175 22.6068 3 22.12 3ZM21.4286 19.38H2.57143V4.62H21.4286V19.38Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7823 8H15.2824C15.1438 8 15.0107 8.07209 14.9291 8.19032L10.8289 14.1826L9.07085 11.6161C8.98934 11.4979 8.85891 11.4258 8.71762 11.4258H7.21772C7.0411 11.4258 6.93785 11.6392 7.0411 11.792L10.4756 16.8096C10.5163 16.8686 10.5694 16.9166 10.6308 16.9497C10.6922 16.9828 10.76 17 10.8289 17C10.8977 17 10.9656 16.9828 11.027 16.9497C11.0884 16.9166 11.1415 16.8686 11.1821 16.8096L16.9589 8.36911C17.0622 8.21339 16.9589 8 16.7823 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 21H8.00001C8.00001 21 8 21.0358 8 21.08V22.92C8 22.9642 8.143 23 8.32 23H15.68C15.857 23 16 22.9642 16 22.92V21.08C16 21.0358 16 21 16 21Z",
			fill: "currentColor"
		})
	]
});
export default SvgQualityMonitor;
